module.exports = __webpack_public_path__ + "files/eb8ddbc2f846203dc4297823e66bfbce.png";